import { useMutation, useQueryClient } from '@tanstack/react-query';
import * as assetApi from '../../../../api/assets';
import { denormaliseData, normaliseData } from '../helpers';
import { IPortalPropertyPhotoAsset } from '../../../../interfaces/asset';

const usePhotoStarToggle = (nhID: number, assetTypeID: number) => {
    const queryClient = useQueryClient();
    const queryKey = ['asset', 'photos'];

    return useMutation({
        mutationFn: async (assetID: number) =>
            assetApi.starAnAsset(assetID, { nhId: nhID, assetTypeID }),
        onMutate: async (updatedStarredAssetID: number) => {
            // prevent any query updates while we perform optimistic update
            await queryClient.cancelQueries({ queryKey });

            // copy the current data as it exists in the react-query store
            const [previousKeyAndData]: any[] = queryClient.getQueriesData({
                queryKey
            });
 
            const previous = previousKeyAndData?.[1] || [];
            
            queryClient.setQueriesData({ queryKey }, (data: IPortalPropertyPhotoAsset[]) => {  
                const normalisedData = normaliseData(data);
                
                normalisedData.properties[nhID]?.photos.forEach((photoID) => {
                    const photo = normalisedData.photos[photoID];
                    if (photo.AssetID === updatedStarredAssetID) {
                        photo.IsStarred = !photo.IsStarred;
                    } else {
                        photo.IsStarred = false;
                    }
                });

                return denormaliseData(normalisedData);
                
            });
            return { previous };
        },
        onError: (error, _, context) => {
            console.log(error);
            // Rollback to the previous state if mutation fails
            if (context?.previous) {
                queryClient.setQueryData(queryKey, context.previous);
            }
        },
        onSettled: () => {
            queryClient.invalidateQueries({
                queryKey,
            });
        }
    });
};

export { usePhotoStarToggle };